<template>
  <aside class="menu column is-one-fifth has-text-left">
    <h2 class="menu-title subtitle is-size-4">MY MENTOR</h2>
    <router-link to="/">
    <p class="menu-label is-size-5 is">MY Dashboard</p>
    </router-link>
    <ul class="menu-list">
      <li>
        <a class="menu-item">My E-Studio</a>
      </li>
      <li>
        <a class="menu-item">Submit a Question</a>
      </li>
    </ul>
  </aside>
</template>
<script>
export default {
  name: "EMenu"
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
.menu-item {
  color: $pantoneBlue;
  border-bottom: 1px solid $pantoneBlue;
}
.menu-title,
.menu-label {
  color: $pantoneBlue;
}

.is-active,
.menu-item:hover,
.menu-label:hover {
  background-color: $pantoneBlue;
  color: white;
}
</style>